<template>
  <div>
    <q-btn color="warning" icon="warning" round @click="dialog = true"
           v-if="photos?.length > 0"/>
    <q-skeleton type="circle" v-else-if="isFetching" style="width: 50px; height: 50px"/>
    <q-dialog v-model="dialog" >
      <q-card class="q-dialog-plugin">
        <q-card-section>
          <div class="text-h6">Похожие фото</div>
        </q-card-section>
        <q-card-section class="q-gutter-xs" v-if="photos">
          <div v-for="photo in photos" :key="photo.id" class="q-ma-xs">
            <q-card class="q-pa-md q-mb-md">
              <!-- Main Photo Display -->
              <q-card-section>
                <q-img :src="photoUrl(photo.address)" height="200px" fit="scale-down" class="rounded-borders"/>
                <div class="q-pt-md text-center text-bold">Фото</div>
              </q-card-section>
              <!-- Similar Photos Section -->
              <q-card-section class="q-gutter-xs q-mt-md">
                <div class="text-caption text-grey">Похожие фото:</div>
                <div class="row q-col-gutter-sm">
                  <div v-for="duplicate in photo.photos" :key="duplicate.id" class="col-6">
                    <q-card flat bordered class="q-pa-xs">
                      <q-card-section>
                        <q-img :src="photoUrl(duplicate.address)" class="rounded-borders" ratio="1" />
                      </q-card-section>
                      <q-card-section>
                        <router-link
                            :to="`/projects/${duplicate.task.project.id}/tasks/${duplicate.task.id}`"
                        >
                          Задача {{ duplicate.task.code }}
                        </router-link>
                      </q-card-section>
                    </q-card>
                  </div>
                </div>
              </q-card-section>
            </q-card>
          </div>
        </q-card-section>
        <q-card-section v-else align="center">
          <q-circular-progress indeterminate rounded size="50px" color="primary" class="q-ma-md"/>
          <h5>Ищем...</h5>
        </q-card-section>
        <q-card-section v-if="photos?.length == 0" align="center">
          <h5>Ничего не найдено</h5>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn color="primary" label="Хорошо" v-close-popup/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup lang="ts">
import {ref, toRefs} from 'vue'
import {useFindSimilarPhotos} from '../composables/task';
import {photoCdnUrl} from "../util/photoCdn";

const dialog = ref(false)
const props = defineProps<{
  taskId: number,
  projectId: number
}>()

const {taskId, projectId} = toRefs(props);

const {data: photos, isFetching} = useFindSimilarPhotos(projectId, taskId)

const photoUrl = (address: string) => photoCdnUrl(address, { encode: true })

</script>
  
  
